<script setup lang="ts">
import { TableOrders } from '@widgets/orders'

import { useCustomerOrdersPage } from '../model/customer-orders-page.hook'

defineOptions({
  name: 'CustomerOrdersPage',
})

useCustomerOrdersPage()
</script>

<template>
  <TableOrders :with-customer="false" />
</template>
